import type { PropsWithChildren } from 'react';

import { cn } from '@/package';

const ContainerContent = ({ children }: PropsWithChildren) => {
  return (
    <div
      className={cn(
        'w-[calc(100vw-var(--spacing-sidebar))] min-w-[calc(var(--container-md)-var(--spacing-sidebar))]',
        'flex-1',
        'px-8',
        'overflow-hidden',
        '@xl:w-[calc(120rem-var(--spacing-sidebar))]',
      )}
    >
      {children}
    </div>
  );
};

export default ContainerContent;
